import z from "zod";

import { connectGrades, GradeKey } from "@/enums/connectGrades";
import { createIdSchema } from "@/schemas/createId";
import { isoDateSchema } from "@/types/isoDate";

const ConnectGradesArraySchema = z.array(
  z.enum(Object.keys(connectGrades) as [GradeKey, ...GradeKey[]]),
);

export const ExperienceBaseSchema = z.object({
  id: z.string(),
  employer: z.string(),
  title: z.string(),
  description: z.string(),
  reasonForLeaving: z.string().nullable(),
  referenceName: z.string().nullable(),
  referencePhone: z.string().nullable(),
  referenceEmail: z.string().nullable(),
  doNotContact: z.boolean(),
  startDate: isoDateSchema,
  endDate: isoDateSchema.nullable(),
  presentlyEmployed: z.boolean(),
});
export type ExperienceBase = z.infer<typeof ExperienceBaseSchema>;

/** Core classifies an assignment against its own subject and grade vocabularies. */
export const ExperienceSchema = ExperienceBaseSchema.extend({
  subjects: z.array(z.string()).nullish(),
  grades: ConnectGradesArraySchema.nullish(),
  experienceTypes: z.array(z.string()).nullish(),
});
export type Experience = z.infer<typeof ExperienceSchema>;

export const ExperienceCreateSchema = ExperienceSchema.extend({
  id: createIdSchema,
});
export type ExperienceCreate = z.infer<typeof ExperienceCreateSchema>;
